import { useGSAP } from '@gsap/react';
import { animateWithGsap } from '../utils/animations';
import Preview from './Preview';
import Receipt from './Receipt';

const Review = ({ build }) => {
  useGSAP(() => {
    animateWithGsap('.rv', { y: 0, opacity: 1, duration: 0.9 });
  }, []);

  return (
    <section id="review" className="bg-white px-5 pb-20 pt-4 sm:px-10 md:pb-28">
      <div className="screen-max-width mx-auto max-w-xl">
        <h2 className="rv g_fadeIn text-3xl font-semibold md:text-5xl">Your website preview</h2>
        <p className="rv g_fadeIn mt-3 text-gray">Order on WhatsApp, pay securely via Razorpay, then share your details. <a href={`${import.meta.env.BASE_URL}terms`} className="text-blue hover:underline">FAQ &amp; terms</a>.</p>
        <div className="rv g_fadeIn mt-8">
          <Preview build={build} />
        </div>
        <Receipt build={build} className="rv g_fadeIn mx-auto mt-10 max-w-sm lg:hidden" />
      </div>
    </section>
  );
};

export default Review;
